import { useIntl } from 'react-intl'
import { useEffect } from 'react'
import { updateLocale } from 'app/configs/momentConfig'

export const useMomentConfig = () => {
  const { locale, formatMessage } = useIntl()

  useEffect(() => {
    updateLocale(locale, formatMessage)
  }, [locale, formatMessage])
}
